export const countryOptions = async () => {
    const allCountries: any = await fetch('https://restcountries.com/v3.1/all?fields=name,cca3').then((response) => response.json());
    const countries = allCountries.map((country: { cca3: string; name: { common: string } }) => ({ value: country.cca3, key: country.name.common.toUpperCase() }));
    // sort countries by name
    return countries.sort((a: { value: string; }, b: { value: string; }) => (a.value > b.value) ? 1 : -1);
};